import { formatIN } from '../kit'

// One figure of the programme report: the value now, large, and under it the
// change since the end of the previous window with an arrow.
//
// The arrow says which way the number went; its colour says whether that is
// good. A rise in critical findings is bad and a rise in vendors on the
// register is neither, so the colour comes from the figure's direction and
// never from the sign alone. The words carry the same meaning, so the card
// reads the same printed in grey.

export type FigureDirection = 'up_good' | 'up_bad' | 'neutral'

export function FigureCard({
  label,
  now,
  previous,
  direction,
  since,
}: {
  label: string
  now: number
  previous: number | null
  direction: FigureDirection
  // The date the previous value was read at, as words ("16 Aug").
  since: string
}) {
  const change = previous == null ? null : now - previous
  let tone = 'flat'
  if (change != null && change !== 0 && direction !== 'neutral') {
    tone = (direction === 'up_bad') === change > 0 ? 'bad' : 'good'
  }
  const moved = change == null ? '' : change === 0 ? 'No change' : (change > 0 ? '+' : '-') + formatIN(Math.abs(change))
  const aria =
    label +
    ': ' +
    formatIN(now) +
    (change == null ? '' : change === 0 ? ', no change since ' + since : ', ' + (change > 0 ? 'up ' : 'down ') + formatIN(Math.abs(change)) + ' since ' + since)

  return (
    <div className={'rpt-fig ' + tone} role="group" aria-label={aria}>
      <span className="rpt-fig-l">{label}</span>
      <b className="rpt-fig-v" aria-hidden="true">
        {formatIN(now)}
      </b>
      {change == null ? (
        <span className="rpt-fig-d" aria-hidden="true">
          No earlier reading
        </span>
      ) : (
        <span className="rpt-fig-d" aria-hidden="true">
          {change !== 0 && <Arrow up={change > 0} />}
          <span className="rpt-fig-c">{moved}</span>
          <span className="rpt-fig-was">
            from {formatIN(previous ?? 0)} on {since}
          </span>
        </span>
      )}
    </div>
  )
}

function Arrow({ up }: { up: boolean }) {
  return (
    <svg className="rpt-arrow" viewBox="0 0 12 12" aria-hidden="true">
      <path d={up ? 'M6 2.5 10 7.5H7v2H5v-2H2z' : 'M6 9.5 2 4.5h3v-2h2v2h3z'} />
    </svg>
  )
}
